export const notInstalledURL = 'not-installed.xhtml';
export const thumbnailWidth = 181;
export const thumbnailHeight = 256;
export const maxZoomRate = 6;
export const popupTitlebarHeight = 56;
export const popupMovableBoundsMargin = 20;
export const defaultPageIFrameBackgrouncColor = { backgroundColor: '#fff' };
export const pageBackdropColor = 'rgb(245, 245, 245)';
export const pageWrapperBorderStyle = '1px solid rgb(180, 180, 180)';
export const defaultLineHeight = 1.75;
export const learningPenColor = 'rgb(254, 140, 6)';

export const zIndex = {
  sheetScaler: -1,
  simpleResizeSensor: -1,
  tabbedViewer: 0,
  primaryToolbar: 1,
  secondaryToolbar: 1,
  bottomToolbar: 1,
  settingPopupTab: 1,
  bottomToolbarToolboxPopup: 1,
  zoomingRegionSelector: 1,
  modelessPopupContainer: 1,
  settingPopup: 2,
  modalPopup: 2,
  helpView: 3,
  savingIndicator: 10,
};
